// script.js
document.addEventListener('DOMContentLoaded', () => {
  $('.ball').hide();
  const ball = document.querySelector('.ball');
  const hero = document.querySelector('.ballcursor');
  let mouseX = window.innerWidth / 2, mouseY = window.innerHeight / 2;
  let ballX = window.innerWidth / 2, ballY = window.innerHeight / 2;
  const speed = 0.05; // Velocità di inseguimento
  const orbitRadius = 30; // Raggio dell'orbita
  let angle = 0;
  let isMouseInside = false;
  var mouseX_last = window.innerWidth / 2, mouseY_last = window.innerHeight / 2;

  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    mouseX = e.clientX - rect.left;
    mouseY = e.clientY - rect.top;
    isMouseInside = true;
    $(".ball").fadeIn(2000);
  });

  hero.addEventListener('mouseleave', (e) => {
    mouseX_last = e.clientX - rect.left;
    mouseY_last = e.clientY - rect.top;
    isMouseInside = false;
    $(".ball").fadeOut(2000);
  });

  function animate() {
    if (isMouseInside) {
      angle += 0.03; // Incrementa l'angolo per l'orbita quando il cursore è dentro
    } else {
      mouseX = mouseX_last;
      mouseY = mouseY_last;
      angle += 0.01; // Orbita più lentamente quando il puntatore è fermo
    }

    const distX = mouseX - ballX;
    const distY = mouseY - ballY;
    ballX += distX * speed;
    ballY += distY * speed;

    const orbitX = ballX + orbitRadius * Math.cos(angle);
    const orbitY = ballY + orbitRadius * Math.sin(angle);

    ball.style.transform = `translate(${orbitX}px, ${orbitY}px)`;

    requestAnimationFrame(animate);
  }

  animate();
});
